module.exports = __webpack_public_path__ + "themes/custom/iidb/dist/img/icon-insta.7b3d2f0c.svg";